import { LOCALES, KEYS } from '../constants';

const zhTWTranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_CHINESE_TW] : {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"合作夥伴角色",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"整合者",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"供應商",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"合作夥伴等級",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"合作夥伴專業化認證",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:" Cisco Powered 服務",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"合作夥伴名稱",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"位置",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"國家/地區",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"合作夥伴名稱關鍵字",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"合作夥伴名稱關鍵字",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"排序",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"專業",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"合作夥伴專業化認證",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"供應商等級與 Cisco Powered 服務",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"金級供應商",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"優質供應商",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"選取供應商",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"獲取指南",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"要求報價",
    [KEYS.L18N_KEY_LABEL_OPEN ]:"開啟",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"擴大需求",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"摺疊",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"請選擇國家/地區",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"選擇角色",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"選擇專業化認證",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"選擇 Cisco Powered 服務",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"選擇專業知識",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"選擇等級",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"合作夥伴國家/地區",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"整合者層級",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"供應商層級",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"整合者專業化認證",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"Cisco Powered 服務",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"合作夥伴名稱",
    [KEYS.L18N_KEY_LABEL_BACK ]:"上一步",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"所有結果",
    [KEYS.L18N_KEY_LABEL_ALL ]:"全部",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"已儲存",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"我的合作夥伴",
    [KEYS.L18N_KEY_LABEL_ADD ]:"新增",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"移除",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"新增至比較 ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"至少再選取一個",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"選取的比較 ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"移除比較器",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"比較",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"合作夥伴等級",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"處理進行中",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"結果",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"結果",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"沒有結果",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"產生",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"結果，在：",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"無結果，在：",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"上一頁",
    [KEYS.L18N_KEY_LABEL_PREV ]:"上一個",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"下一步",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"儲存",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"專業技術內容",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"概觀",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"為思科",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"整合者為我們的客戶打造端對端解決方案。他們主要以動態轉售的方式進行交易，但是會提供其獨特的專業知識來為客戶解決業務問題",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"供應商是提供託管雲端解決方案的專家。客戶在如何運用解決方案上尋求更大的彈性，因此，供應商在市場上也就更加重要。",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"過去的搜尋",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"過去的搜尋",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"角色 ",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"科技",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"產業",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"整合者",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"供應商",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"其他",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"其他",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"未儲存其他合作夥伴",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"未儲存整合者",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"未儲存供應商",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"按需求篩選",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"按組合條件搜尋",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"按位置搜尋",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"有 1 位合作夥伴提供全球的服務",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"有",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"位合作夥伴提供全球的服務",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"無合作夥伴提供服務",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"有 1 位合作夥伴提供服務於",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"位合作夥伴提供服務於",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"無合作夥伴提供服務於",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"變更地點",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"按需求篩選",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"搜尋",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"依名稱、等級與專業知識",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"已選取",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"找不到相符結果",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"遞增排名",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"遞減排名",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"按名稱遞增排列",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"按名稱遞減排列",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"必須登入",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"您必須登入才能執行此動作",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"還原搜尋失敗",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"登入",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"已成功儲存合作夥伴",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"無法儲存合作夥伴",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"合作夥伴已成功移除",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"無法刪除合作夥伴",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"按名稱、等級或專業知識輸入關鍵字",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"開發人員是在思科強大技術的基礎上量身打造軟硬體解決方案的專家，能夠透過獨特的解決方案來整合系統，以提供出色的成果。",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"顧問是具備深厚產業知識的專家，能夠指導企業探索各種解決方案，以因應複雜的業務挑戰。",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"多樣化的合作夥伴",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"字母順序",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"最多的專業知識",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"開發人員",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"顧問",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"篩選條件",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"篩選",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"合作夥伴專業知識",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"解除",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"專業化認證",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"專業知識",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"無提供描述。",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"關於",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"清除比較器",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"合作夥伴比較",
    [KEYS.L18N_KEY_LABEL_ROLE]:"角色",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"科技重心",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"說明",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"選擇語言",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"登出",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"包容性的合作夥伴",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]:"關於思科",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]:"聯繫我們",
    [KEYS.L18N_KEY_LABEL_CAREERS]:"職業",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]:"認識我們的合作夥伴",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]:"反饋",
    [KEYS.L18N_KEY_LABEL_HELP]:"幫助",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]:"條款和條件",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]:"隱私聲明",
    [KEYS.L18N_KEY_LABEL_COOKIES]:"餅乾",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]:"商標",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]:"供應鏈透明度",
    [KEYS.L18N_KEY_LABEL_SITEMAP]:"站點地圖",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "關於思科",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "聯繫我們",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "職業",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "認識我們的合作夥伴",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "反饋",
    [KEYS.L18N_KEY_LABEL_HELP]: "幫助",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "條款和條件",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "隱私聲明",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "餅乾",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "商標",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "供應鏈透明度",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "站點地圖",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "如何購買",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "合作夥伴",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "產品和服務",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "解決方案",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "支持",
    [KEYS.L18N_KEY_LABEL_LEARN]: "學習",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "探索思科",
    [KEYS.L18N_KEY_LABEL_MENU]: "菜單",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "關閉",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "查看更多",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "少看",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "沒有賬戶？",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "註冊"
  }
});

export default zhTWTranslations;
